export default __webpack_public_path__ + "static/media/hero.86c6cc07.png";